import useCategories from "../../hooks/use-categories";
import useLocalization from "../../hooks/use-localization";
import classnames from 'classnames';

export default function CategoriesFilter({ selected, action }) {

    const categories = useCategories();
    const localization = useLocalization();

    const handleClick = function (c) {
        action(c);
    }

    const allClassNames = classnames("filter-item", selected === 'all' && 'filter-item-selected');
    let renderedCategories = [<span
        className={allClassNames}
        key='all'
        onClick={() => handleClick('all')}>
        {localization.all}
    </span>];

    for (const category in categories) {
        const classNames = classnames("filter-item", selected === category && 'filter-item-selected');
        renderedCategories.push(
            <span
                className={classNames}
                key={category}
                onClick={() => handleClick(category)}>
                {categories[category]}
            </span>
        );
    }

    return (
        <div className="news-category-filter">
            {renderedCategories}
        </div>
    )
}